// .category-submenu-text要素を全て取得する
const accordionItems = document.querySelectorAll('.category-ey-genre');
const categorysubmenu = document.querySelectorAll('.category-ey-genre-menu');
const headerEyText = document.querySelector('.header-ey-text');
const categoryoverlay = document.querySelector('.category-overlay');
const headerEybrand = document.querySelector('.header-ey-brand');
const brandoverlay = document.querySelector('.brand-overlay');
const categoryClose = document.querySelector('.category-close');
const brandClose = document.querySelector('.brand-close');
let openedIndex = null;


headerEyText.addEventListener('click', function() {
    categoryoverlay.style.display = 'block';
  });

  categoryClose.addEventListener('click', function() {
    categoryoverlay.style.display = 'none';
  });
  //こっちはブランドがクリックされたときの記述
headerEybrand.addEventListener('click', function() {
    brandoverlay.style.display = 'block';
  });

  brandClose.addEventListener('click', function() {
    brandoverlay.style.display = 'none';
  });
// 各アイテムにクリックイベントを追加する
accordionItems.forEach((item, index) => {
  item.addEventListener('click', () => {
    if (item.classList.contains('active')) {
      categorysubmenu[index].style.height = 0;
      item.classList.toggle('active');
      categorysubmenu[index].classList.toggle('active');
      openedIndex = null; // 閉じる場合にはopenedIndexをnullにする
      
    } else {
      if (openedIndex !== null) {
        // 他のcategory-submenuが開かれている場合、閉じる
        categorysubmenu[openedIndex].style.height = 0;
        accordionItems[openedIndex].classList.toggle('active');
        categorysubmenu[openedIndex].classList.toggle('active');
      }
      categorysubmenu[index].style.height = 'auto';
      categorysubmenu[index].classList.toggle('active');
      let itemHeight = categorysubmenu[index].offsetHeight;
      categorysubmenu[index].style.height = itemHeight + 'px';
      categorysubmenu[index].animate(
        [
          { height: 0 },
          { height: itemHeight + 'px' },
        ],
        {
          duration: 300,
        }
      );
      item.classList.toggle('active');
      openedIndex = index;
    }
  });
});